/* unplugin-vue-components disabled */import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ExtFieldPc.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Base/Scroll/index.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "order-product"
  }, [_c(__unplugin_components_0, {
    ref: "orderList",
    staticClass: "flex1",
    on: {
      "pulling-down": _vm.onPulldownLoading,
      "pulling-up": _vm.onPullupLoading
    }
  }, _vm._l(_vm.orderReport, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "order-item card"
    }, [_c('div', {
      staticClass: "header"
    }, [_c('div', {
      staticClass: "font-size-h3-large smy__text-overflow-one-line title"
    }, [_c('div', {
      staticClass: "temp-icon"
    }, [_c('img', {
      attrs: {
        "src": '/spa_static/templateIcon/template-10-0.png',
        "width": "100%",
        "height": "100%"
      }
    })]), _c('div', {
      staticClass: "content smy__text-overflow-one-line"
    }, [_c('span', [_vm._v(_vm._s(item.productionName))])])])]), _c('div', {
      staticClass: "content block"
    }, [_vm._l(_vm.sysList, function (sys, index) {
      return _c('div', {
        key: index,
        staticClass: "font-size-h4-large line flex-between",
        staticStyle: {
          "margin-top": "0.6rem"
        }
      }, [_c('span', {
        staticClass: "line-name-list"
      }, [_vm._v(_vm._s(sys.name))]), _c('span', [_vm._v(" " + _vm._s(item[sys.key]) + " ")])]);
    }), _c(__unplugin_components_1, {
      attrs: {
        "size": "h4",
        "level": "large",
        "extFields": item.fvs ? item.fvs.map(function (v) {
          return Object.assign({}, v, {
            tfname: v.NAME
          });
        }) : []
      }
    })], 2)]);
  }), 0)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };